import React from "react";
import { useTranslation } from "react-i18next";
import { ArrowUpRightSquare, Globe2 } from "lucide-react";

import { Button } from "./ui/button";

const LANGUAGES = [
  { code: "pt", label: "Português" },
  { code: "en", label: "English" },
  { code: "es", label: "Español" },
];

const NAV_LINKS = [
  { href: "/#home", labelKey: "appbar.home" },
  { href: "/#destinations", labelKey: "appbar.destinations" },
  { href: "/#tours", labelKey: "appbar.tours" },
];

export default function Footer() {
  const { t, i18n } = useTranslation();
  const year = new Date().getFullYear();

  const handleLanguageChange = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    i18n.changeLanguage(event.target.value);
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="relative mt-16 bg-slate-950 text-slate-100">
      <div className="absolute inset-x-0 top-0 h-1 bg-gradient-to-r from-primary to-orange-300" />
      <div className="mx-auto flex max-w-6xl flex-col gap-10 px-6 py-12">
        <div className="flex flex-col gap-6 md:flex-row md:items-center md:justify-between">
          <div>
            <p className="text-sm uppercase tracking-[0.4em] text-primary">
              Transfer On Floripa
            </p>
            <h3 className="mt-2 text-2xl font-semibold">{t("home.welcome")}</h3>
          </div>
          <Button
            variant="ghost"
            className="w-full justify-between rounded-full border border-white/20 text-slate-100 hover:bg-white/10 md:w-auto"
            onClick={scrollToTop}
          >
            {t("footer.toTop")}
            <ArrowUpRightSquare className="h-4 w-4" />
          </Button>
        </div>
        <div className="flex flex-col gap-8 border-t border-white/10 pt-8 md:flex-row md:items-center md:justify-between">
          <nav className="flex flex-wrap gap-4 text-sm font-medium">
            {NAV_LINKS.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="rounded-full bg-white/5 px-4 py-2 transition hover:bg-white/10"
              >
                {t(link.labelKey)}
              </a>
            ))}
          </nav>
          <label className="flex items-center gap-3 text-sm text-slate-300">
            <Globe2 className="h-4 w-4" />
            <select
              value={i18n.language}
              onChange={handleLanguageChange}
              className="rounded-full border border-white/20 bg-transparent px-4 py-2 text-slate-100 focus:outline-none"
            >
              {LANGUAGES.map((lang) => (
                <option
                  key={lang.code}
                  value={lang.code}
                  className="text-slate-900"
                >
                  {lang.label}
                </option>
              ))}
            </select>
          </label>
        </div>
        <div className="flex flex-col gap-2 border-t border-white/10 pt-6 text-sm text-slate-400 md:flex-row md:items-center md:justify-between">
          <span>
            &copy; {year} Transfer On Floripa. {t("footer.info")}
          </span>
          <span>
            {t("footer.developedBy")}{" "}
            <a
              href="https://richardpompeo.com.br"
              target="_blank"
              rel="noreferrer"
              className="font-semibold text-white hover:text-primary"
            >
              Richard Pompeo
            </a>
          </span>
        </div>
      </div>
    </footer>
  );
}
